module.exports = __webpack_public_path__ + "static/media/giftsReceived_3000_5000.5eb356b3.png";